import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { browser } from '../../../../../common';

import Rustore from '../../../../../assets/download-mobile/rustore.svg';
import RustoreSm from '../../../../../assets/download-mobile/rustore-sm.svg';
import Appstore from '../../../../../assets/download-mobile/appstore.svg';
import AppstoreSm from '../../../../../assets/download-mobile/appstore-sm.svg';
import Appgallery from '../../../../../assets/download-mobile/appgallery.svg';
import AppgallerySm from '../../../../../assets/download-mobile/appgallery-sm.svg';
import Apk from '../../../../../assets/download-mobile/apk.svg';
import ApkSm from '../../../../../assets/download-mobile/apk-sm.svg';

import * as styles from './index.module.scss';

const BUTTONS = [
  {
    name: 'rustore',
    os: 'android',
    link: 'https://www.rustore.ru/catalog/app/com.cupiszenitapp',
    Icon: Rustore,
    IconSm: RustoreSm,
  },
  {
    name: 'appstore',
    os: 'ios',
    link: 'https://apps.apple.com/ru/app/зенит-ставки-на-спорт/id1579892801',
    Icon: Appstore,
    IconSm: AppstoreSm,
  },
  {
    name: 'appgallery',
    os: 'android',
    link: 'https://appgallery.huawei.com/#/app/C109236679',
    Icon: Appgallery,
    IconSm: AppgallerySm,
  },
  {
    name: 'apk',
    os: 'android',
    link: 'https://zenit.win/ajax/mobile_app/download',
    Icon: Apk,
    IconSm: ApkSm,
  },
];

export const Buttons = (props) => {
  const { color = 'light', isMobileMinified = false, className, buttonClassName } = props;
  const [os, setOs] = useState(null);

  useEffect(() => {
    const { ios, android } = browser();
    if (ios) setOs('ios');
    else if (android) setOs('android');
  }, []);

  const buttons = BUTTONS.filter((button) => !os || button.os === os);

  return (
    <div
      className={classNames(styles.buttons, styles[color], className, {
        [styles.minified]: isMobileMinified,
      })}
    >
      {buttons.map(({ name, link, Icon, IconSm }) => (
        <a
          key={name}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className={classNames(styles.button, buttonClassName)}
          data-testid={`download-button-${name}`}
        >
          <Icon className={styles.icon} />
          {isMobileMinified && <IconSm className={styles.iconSm} />}
        </a>
      ))}
    </div>
  );
};
